module.exports = __webpack_public_path__ + "static/img/settle-img.6c74db2d.png";